import VoidMessageModal from './VoidMessageModal';

export default VoidMessageModal;
